<template>
  <b-container>
    <b-row align-h="center" align-v="center" style="height: 80vh">
      <b-col cols="7">
        <h2  class="mb-4 text-center">Reset your password: {{email}}</h2>
        <b-form-group
            id="fieldset-1"
            :label="$t('registerLabelPassword')"
            label-for="input-3"
            :invalid-feedback="invalidFeedbackPassword"
            :state="verifyPassword"
        >
          <b-form-input v-on:keyup.enter="verifyForm"
                        v-bind:placeholder="$t('loginPlaceHolderPassword')" type="password"
                        id="input-3" v-model="password" :state="verifyPassword" trim></b-form-input>
        </b-form-group>
        <b-form-group
            id="fieldset-5"
            :label="$t('registerLabelRepeatedPassword')"
            label-for="input-5"
            :invalid-feedback="invalidFeedbackPassword"
            :state="verifyPassword"
        >
          <b-form-input v-on:keyup.enter="verifyForm"
                        v-bind:placeholder="$t('loginPlaceHolderPassword')" type="password"
                        id="input-5" v-model="repeatedPassword" :state="verifyPassword"
                        trim></b-form-input>
        </b-form-group>
        <button v-on:click="verifyForm" type="button" class="btn btn-danger form-control-sm">
          {{ $t('resetPasswordBtn') }}
        </button>
      </b-col>

    </b-row>

  </b-container>
</template>

<script>

import apiService from "@/service/service";

export default {
  name: "ResetPassword",
  data: () => {
    return {
      company: '',
      email: '',
      password: '',
      repeatedPassword: '',
      invalidFeedbackPassword: '',
      verifyPassword: null,
      date: null
    }
  },
  methods: {
    verifyForm() {
      this.verifyPassword = this.password.length > 6 && this.password === this.repeatedPassword ? null : false
      this.invalidFeedbackPassword = this.password.length > 6 ? '' : this.$i18n.t('errorMessageLengthPassword').toString()
      if (this.password.length > 6) {
        this.invalidFeedbackPassword = this.password === this.repeatedPassword ? null : this.$i18n.t('errorMessageSamePassword').toString()
      }
      if (this.verifyPassword === null) {
        this.$store.commit('updateIsLoading', true)
        this.resetPassword()
      }
    },
    async resetPassword(){
      try {
        const user = {
          email: this.email,
          company: this.company,
          date: this.date,
          password: this.password
        }
        await apiService.sendNewPassword(user)
        this.$store.commit('updateIsLoading', false)
        this.$bvToast.toast(this.$i18n.t('successMessageResetPassword').toString(), {
          variant: 'success',
          solid: true
        })
        this.resetValues()

      }catch (e) {
        console.log(e.response.data.error)
        switch (e.response.error){
          case 'Date expires':
            this.$bvToast.toast(this.$i18n.t('errorMessageDateExpires').toString(), {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
                break
          case 'User does not exist':
            this.$bvToast.toast(this.$i18n.t('errorMessageUserNotExist').toString(), {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
            break
          default:

        }
        this.resetValues()
        this.$store.commit('updateIsLoading', false)
      }

    },
    resetValues(){
      this.password = ''
      this.repeatedPassword = ''
    },
    verifyData() {
      try {
        if (!this.email || !this.company || !this.date) throw Error('No data')
        if (this.date) {
          const newDate = new Date()
          //newDate.setDate(newDate.getDate() + 1)
          if (newDate > this.date) throw Error('Date expired')
        }
      } catch (e) {
        this.$bvToast.toast(this.$i18n.t('errorMessageDateExpires').toString(), {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
        console.log(e.message)

      }
    }

  },
  created() {
    this.company = this.$route.query.company
    this.email = this.$route.query.user
    this.date = new Date(this.$route.query.limitDate.toString())
    this.verifyData()
  }
}
</script>

<style scoped>

</style>